export const difficultyScoreMultipliers = {
  easy: 1,
  normal: 2,
  hard: 5,
  nightmare: 10,
};
